import { render, staticRenderFns } from "./AddOfferDatesSuggestion.vue?vue&type=template&id=165a403a&"
import script from "./AddOfferDatesSuggestion.vue?vue&type=script&lang=js&"
export * from "./AddOfferDatesSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports